/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How an accepted result matched the expected output.
 * @export
 */
export const AcceptedBy = {
    Exact: 'exact',
    Tolerance: 'tolerance'
} as const;
export type AcceptedBy = typeof AcceptedBy[keyof typeof AcceptedBy];


export function instanceOfAcceptedBy(value: any): boolean {
    for (const key in AcceptedBy) {
        if (Object.prototype.hasOwnProperty.call(AcceptedBy, key)) {
            if (AcceptedBy[key as keyof typeof AcceptedBy] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AcceptedByFromJSON(json: any): AcceptedBy {
    return AcceptedByFromJSONTyped(json, false);
}

export function AcceptedByFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptedBy {
    return json as AcceptedBy;
}

export function AcceptedByToJSON(value?: AcceptedBy | null): any {
    return value as any;
}

export function AcceptedByToJSONTyped(value: any, ignoreDiscriminator: boolean): AcceptedBy {
    return value as AcceptedBy;
}

